/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoItemShopPurchaseLogListListData model module.
 * @module model/LogControllerDtoItemShopPurchaseLogListListData
 * @version 1.0
 */
class LogControllerDtoItemShopPurchaseLogListListData {
    /**
     * Constructs a new <code>LogControllerDtoItemShopPurchaseLogListListData</code>.
     * @alias module:model/LogControllerDtoItemShopPurchaseLogListListData
     */
    constructor() { 
        
        LogControllerDtoItemShopPurchaseLogListListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoItemShopPurchaseLogListListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoItemShopPurchaseLogListListData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoItemShopPurchaseLogListListData} The populated <code>LogControllerDtoItemShopPurchaseLogListListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoItemShopPurchaseLogListListData();

            if (data.hasOwnProperty('purchaseNo')) {
                obj['purchaseNo'] = ApiClient.convertToType(data['purchaseNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('productNo')) {
                obj['productNo'] = ApiClient.convertToType(data['productNo'], 'Number');
            }
            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('itemCount')) {
                obj['itemCount'] = ApiClient.convertToType(data['itemCount'], 'Number');
            }
            if (data.hasOwnProperty('priceType')) {
                obj['priceType'] = ApiClient.convertToType(data['priceType'], 'Number');
            }
            if (data.hasOwnProperty('price')) {
                obj['price'] = ApiClient.convertToType(data['price'], 'Number');
            }
            if (data.hasOwnProperty('transactionNo')) {
                obj['transactionNo'] = ApiClient.convertToType(data['transactionNo'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoItemShopPurchaseLogListListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoItemShopPurchaseLogListListData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} purchaseNo
 */
LogControllerDtoItemShopPurchaseLogListListData.prototype['purchaseNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoItemShopPurchaseLogListListData.prototype['accountNo'] = undefined;

/**
 * @member {Number} productNo
 */
LogControllerDtoItemShopPurchaseLogListListData.prototype['productNo'] = undefined;

/**
 * @member {Number} itemId
 */
LogControllerDtoItemShopPurchaseLogListListData.prototype['itemId'] = undefined;

/**
 * @member {Number} itemCount
 */
LogControllerDtoItemShopPurchaseLogListListData.prototype['itemCount'] = undefined;

/**
 * @member {Number} priceType
 */
LogControllerDtoItemShopPurchaseLogListListData.prototype['priceType'] = undefined;

/**
 * @member {Number} price
 */
LogControllerDtoItemShopPurchaseLogListListData.prototype['price'] = undefined;

/**
 * @member {Number} transactionNo
 */
LogControllerDtoItemShopPurchaseLogListListData.prototype['transactionNo'] = undefined;

/**
 * @member {Number} status
 */
LogControllerDtoItemShopPurchaseLogListListData.prototype['status'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoItemShopPurchaseLogListListData.prototype['createdAt'] = undefined;






export default LogControllerDtoItemShopPurchaseLogListListData;

